import { Tabs, Tab } from "@mui/material";
import React from "react";

export interface Dashboard {
  name: string;
  url: string;
}

interface DashboardSelectorProps {
  dashboards: Dashboard[];
  currentDashboard: Dashboard | null;
  onDashboardChange: (dashboard: Dashboard) => void;
}

const DashboardSelector: React.FC<DashboardSelectorProps> = ({
  dashboards,
  currentDashboard,
  onDashboardChange,
}) => {
  const handleChange = (event: React.SyntheticEvent, newValue: string) => {
    const selectedDashboard = dashboards.find(db => db.url === newValue);
    if (selectedDashboard) {
      onDashboardChange(selectedDashboard);
    }
  };

  return (
    <Tabs
      value={currentDashboard?.url || false}
      onChange={handleChange}
      variant="scrollable"
      scrollButtons="auto"
      allowScrollButtonsMobile
      indicatorColor="secondary"
      textColor="inherit"
      aria-label="Dashboard tabs"
      sx={{ 
        borderBottom: 1, 
        borderColor: 'divider',
        minHeight: 'auto',
        '& .MuiTab-root': {
          minWidth: '110px',
          fontSize: '0.875rem',
          color: 'rgba(255, 255, 255, 0.7)',
          '&.Mui-selected': {
            color: 'white',
          }
        }
      }}
    >
      {dashboards.map((dashboard) => (
        <Tab
          key={dashboard.url}
          label={dashboard.name}
          value={dashboard.url}
          wrapped
        />
      ))}
    </Tabs>
  );
};

export default React.memo(DashboardSelector); 